<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-4" v-if="cargando">
      <b-button variant="primary" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </div>

    <div class="mt-4" v-else>
      <b-row>
        <b-col>
          <b-form-group
              class="text-left"
              v-if="$localStorageService.can('AS_01_ver_clinica')"
          >
            <label>Clínica</label>
            <b-input-group>
              <b-input-group-prepend is-text>
                <span><em class="fa fa-hospital-o"></em></span>
              </b-input-group-prepend>
              <b-form-select
                  v-model="clinicaSeleccionada"
                  :options="listaClinica"
                  value-field="idClinica"
                  text-field="strNombre"
                  v-on:change="obtenerSesiones"
              >
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button class="mb-4" variant="primary" disabled v-if="buscando">
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>

      <div v-else>
        <div v-if="datosTabla.length === 0">
          <b-alert variant="danger" show>No existen datos</b-alert>
        </div>

        <div v-else>
          <b-input-group size="sm">
            <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Buscar"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
              >Limpiar
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              responsive
          >
            <template v-slot:cell(horaInicio)="row">
              {{ row.item.horaInicio | formatoHora }}
            </template>
            <template v-slot:cell(horaFin)="row">
              <b-form-timepicker
                  v-model="row.item.horaFin"
                  v-if="row.item.cambiarHorario"
              ></b-form-timepicker>
              <span v-else> {{ row.item.horaFin | formatoHora }} </span>
            </template>
            <template v-slot:cell(precioTotal)="row">
              {{ row.item.precioTotal | moneda }}
            </template>
            <template v-slot:cell(acciones)="row">
              <b-button variant="outline-primary" v-if="row.item.cargando">
                <b-spinner small></b-spinner>
              </b-button>
              <b-button-group v-else>
                <b-button
                    v-if="
                    (row.item.idEstatus === 15 || row.item.idEstatus === 2) &&
                    $localStorageService.can('AS_01_admin_ses_abrir')
                  "
                    title="Abrir"
                    variant="outline-primary"
                    @click="abrirModal(row.item, row.index, 2)"
                ><em class="fa fa-folder-open"></em
                ></b-button>
                <b-button
                    v-if=" row.item.tipoRecibo === 2 &&
                    row.item.idEstatus === 1 &&
                    row.item.idEstatusRecibo === 1 &&
                    row.item.idRecibo !== null &&
                    $localStorageService.can('AS_01_cancelar_recibo')
                  "
                    title="Cancelar Recibo"
                    variant="outline-primary"
                    @click="abrirModal(row.item, row.index, 3)"
                ><em class="fa fa-file"></em
                ></b-button>
                <b-button
                    v-if=" row.item.idEstatus === 1 && row.item.idEstatusRecibo === 1 && row.item.tipoRecibo === 1 && row.item.idRecibo !== null &&
                    $localStorageService.can('CR_01_cancelar_reciboPTI')
                  "
                    title="Cancelar Recibo PTI"
                    variant="outline-primary"
                    @click="abrirModal(row.item, row.index, 3)"
                ><em class="fa fa-file"></em
                ></b-button>
                <b-button
                    v-if="row.item.idEstatus === 1 && $localStorageService.can('AS_01_admin_ses_cancel')"
                    title="Cerrar"
                    variant="outline-warning"
                    @click="abrirModalCerrarSesion(row.item, row.index, 1)"
                ><em class="fa fa-close"></em
                ></b-button>
                <b-button
                    v-if="$localStorageService.can('AS_01_admin_ses_horari')"
                    title="Cambiar salida"
                    variant="outline-success"
                    @click="cambiarSalida(row.item)"
                >
                  <b-icon icon="alarm"></b-icon
                  >
                </b-button>
                <b-button
                    v-if="$localStorageService.can('AS_01_admin_ses_saldo')"
                    title="Saldo a favor"
                    variant="outline-info"
                    @click="cambiarSaldoFavor(row.item)"
                >
                  <b-icon icon="calculator"></b-icon
                  >
                </b-button>
                <b-button
                    v-if="
                    row.item.noTratamientos > 0 &&
                    $localStorageService.can('AS_01_admin_ses_pago')
                  "
                    title="Cambiar precios"
                    variant="outline-secondary"
                    @click="cambiarPrecio(row.item)"
                >
                  <b-icon icon="cash-stack"></b-icon
                  >
                </b-button>
                <b-button
                    v-if="row.idPti!== null && $localStorageService.can('PT_01_pti_cancelar')"
                    title="Cancelar pti"
                    variant="danger"
                    @click="abrirModal(row.item, row.index, 4)"
                ><em class="fa fa-ban"></em
                ></b-button>
                <b-button
                    v-if="$localStorageService.can('PT_01_pti_activar')"
                    title="Activar pti"
                    variant="success"
                    @click="activarPTI(row.item)"
                ><em class="fa fa-check-circle-o"></em
                ></b-button>
              </b-button-group>
            </template>
          </b-table>
          <b-pagination
              v-if="datosTabla.length > 1"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
          ></b-pagination>

          <b-modal
              ref="precios"
              size="xl"
              :title="`Cambio de precios (${nombrePaciente})`"
              hide-footer
              no-close-on-backdrop
          >
            <precioTrt :tratamientos="listaTrt" :empleados="lstEmpleados" :motivos="lstMotivos" :lstPlanesPaciente="lstPlanesPaciente"/>
          </b-modal>

          <b-modal
              ref="saldo"
              size="md"
              :title="`Saldo a favor (${nombrePaciente})`"
              hide-footer
          >
            <saldoFavor :idPaciente="idPaciente"/>
          </b-modal>

          <b-modal
              v-model="modalMotivo"
              title="Seleccionar motivo"
              centered
              size="lg"
              no-close-on-backdrop
          >
            <b-col>
              <label class="mr-sm-2" for="motivo">Motivo * </label>
              <v-select
                  id="motivo"
                  label="descripcion"
                  v-model="motivo"
                  :options="motivosFiltrados"
                  required
                  placeholder="Seleccionar motivo"
              ></v-select>
              <div class="mt-3" v-if="tratamientosActuales.length> 0 ">
                <p class="alert text-center alert-info">La sesión tiene tratamientos actuales. <br>¿Deseas ponerlos en estatus
                  <b>Programado</b>  ?
                </p>
                <table class="table table-sm table-striped table-hover table-condensed">
                  <thead>
                  <tr>
                    <th>Nombre del tratamiento:</th>
                    <th>Nombre del OG:</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="tratamiento in tratamientosActuales" :key="tratamientosActuales.indexOf(tratamiento)">
                    <td>{{ tratamiento.tratamiento }}</td>
                    <td>{{ tratamiento.doctor }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </b-col>
            <div slot="modal-footer">
              <b-button
                  v-if="tratamientosActuales.length > 0"
                  variant="outline-primary"
                  :disabled="loaderAcciones"
                  @click="actualesToProgramados()"
              >
                <span v-if="!loaderAcciones">Actualizar tratamientos</span>
                <span v-if="loaderAcciones">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
              </b-button>
              <b-button
                  v-if="tratamientosActuales.length=== 0"
                  variant="outline-primary"
                  :disabled="loaderAcciones"
                  @click="acciones()"
              >
                <span v-if="!loaderAcciones">Guardar</span>
                <span v-if="loaderAcciones">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
              </b-button>
              <b-button
                  variant="outline-danger"
                  :disabled="loaderAcciones"
                  @click="cerrarModal()"
              >Cancelar
              </b-button
              >
            </div>
          </b-modal>
          <b-modal
              v-model="modalActivarPTI"
              title="Seleccionar PTI"
              centered
              size="lg"
              no-close-on-backdrop
          >
            <b-col>
              <label class="mr-sm-2" for="motivo">Motivo * </label>
              <v-select
                  id="motivo"
                  label="descripcion"
                  v-model="motivo"
                  :options="motivosFiltrados"
                  required
                  placeholder="Seleccionar motivo"
              ></v-select>
              <label class="mr-sm-2" for="pti">PTI * </label>
              <v-select
                  id="pti"
                  v-model="ptiSeleccionado"
                  label="Solo field"
                  :options="lstIdsPtis"
                  required
                  placeholder="Seleccionar PTI"
              ></v-select>
            </b-col>
            <div slot="modal-footer">
              <b-button
                  variant="outline-primary"
                  :disabled="loaderAcciones"
                  @click="guardarActivacionPti()"
              >
                <span v-if="!loaderAcciones">Guardar</span>
                <span v-if="loaderAcciones">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
              </b-button>
              <b-button
                  variant="outline-danger"
                  :disabled="loaderAcciones"
                  @click="cerrarModaLActivarPTI()"
              >Cancelar
              </b-button
              >
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import precioTrt from "./PrecioTratamientoSesion.vue";
import saldoFavor from "./SaldoFavorModal.vue";
import _ from "lodash";

export default {
  name: "AdministracionTratamientos",
  components: {
    precioTrt,
    saldoFavor,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      tratamientosActuales: [],
      datosTabla: [],
      fields: [
        {key: "paciente", label: "Nombre del paciente"},
        {key: "doctor", label: "Doctor"},
        {key: "horaInicio", label: "Hora entrada"},
        {key: "horaFin", label: "Hora salida"},
        {key: "noTratamientos", label: "Tx"},
        {key: "precioTotal", label: "Pago"},
        {key: "estatus", label: "Estatus", sortable: true},
        {key: "acciones", label: "Acciones"},
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      filter: null,
      filterOn: [],
      clinicas: [],
      totalRows: null,
      clinicaSeleccionada: null,
      nombrePaciente: null,
      listaTrt: [],
      motivos: [],
      motivosFiltrados: [],
      motivo: null,
      index: null,
      item: null,
      accion: null,
      idPaciente: null,
      cargando: true,
      buscando: false,
      modalMotivo: false,
      loaderAcciones: false,
      lstEmpleados:[],
      lstMotivos:[],
      lstPlanesPaciente:[],
      modalActivarPTI: false,
      lstIdsPtis:[],
      ptiSeleccionado: null
    };
  },
  created() {
    this.clinicaSeleccionada = this.$localStorageService.getIdClinica();
    this.obtenerClinicas();
    this.obtenerMotivos();
    this.obtenerSesiones();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerEmpleados(){
      const params = {
        idClinica: this.clinicaSeleccionada
      }
       this.$http.post(this.$api + "sesion/listaPerfilEmpleadosPorClinica", params).then((response) => {
            if (response.data.data) {this.lstEmpleados = response.data.data}
          }).catch(() => {
            this.mostrarMensajeError("Ocurrio un error al traer los registros.");
          })

        this.$http.get(this.$api + "sesion/listaMotivosAjustesPrecio").then((response) => {this.lstMotivos = response.data.data
        }).catch(() => {
          this.mostrarMensajeError("Ocurrio un error al traer los registros.");
        })

    },
    async actualesToProgramados() {
      for (let item of this.tratamientosActuales) {
        await this.actulizarEstatusTratamiento(item, 2)
      }
      this.obtenerTratamientosActuales();
    },
    async actulizarEstatusTratamiento(tratamiento, opcion) {
      tratamiento.opcion = opcion;
      tratamiento.idSesion = this.idSesion;
      tratamiento.idUsuario = this.$localStorageService.getIdUsuario();
      return this.$http
          .post(
              this.$api + "tratamiento_sesion/cambiarestatustratamiento/",
              tratamiento
          )
          .then((response) => {
            if (response.data.data) {
              this.mostrarMensajeExito("Datos guardados con Éxito");
            }
          })
          .catch(() => {
            this.mostrarMensajeError("No se pudo guardar, intente más tarde.");
          })
    },
    mostrarMensajeExito(mensaje) {
      this.$swal({
        icon: "success",
        text: mensaje,
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    mostrarMensajeError(mensaje) {
      this.$swal({
        icon: "error",
        text: mensaje,
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    obtenerClinicas() {
      const url = this.$api + "catalogos/listaClinicas";
      this.$http.get(url).then((response) => {
        if (response.data.data) {
          response.data.data.unshift({
            idClinica: null,
            strNombre: "Clínica:",
          });
          this.listaClinica = response.data.data;
          this.cargando = false;
        }
      });
    },
    obtenerMotivos() {
      this.$http.get(this.$api + "catalogos/motivos").then((respuesta) => {
        if (respuesta.data.data) {
          this.motivos = respuesta.data.data;
        }
      });
    },
    abrirModalCerrarSesion(item, index, accion) {
      this.motivosFiltrados = [];
      this.accion = accion;
      this.index = index;
      this.item = item;
      this.motivo = null;
      this.motivosFiltrados = this.motivos.filter(
          (value) => value.accion === accion
      );
      this.modalMotivo = true;
      this.idSesion = item.idSesion;
      this.idPaciente = item.idPaciente;
      this.obtenerTratamientosActuales()
    },
    obtenerTratamientosActuales() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
          .post(this.$api + "tratamiento_sesion/listadotratamientosactuales", parametros)
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.tratamientosActuales = [];
              resultado.forEach((item) => {
                this.tratamientosActuales.push({
                  noTratamiento: item.idTratamiento,
                  id: item.idTratamientoProgramado,
                  tratamiento: item.nombreTratamiento,
                  od: item.numeroDiente,
                  ses: item.numeroSesion,
                  doctor: item.doctor,
                  desc: item.descuento,
                  precio: item.precioSesion,
                  idEmpleado: item.idEmpleado,
                  noMaxSesion: item.noMaxSesion,
                  nombrePlan: item.nombrePlan,
                  presupuestoHistorico: item.presupuestoHistorico,
                  idSesion: item.idSesion
                });
              })
              this.tratamientosActuales = _.orderBy(this.tratamientosActuales, ["tratamiento"], ["asc"]);
            }
          })
    },
    abrirModal(item, index, accion) {
      this.motivosFiltrados = [];
      this.accion = accion;
      this.index = index;
      this.item = item;
      this.motivo = null;
      this.motivosFiltrados = this.motivos.filter(
          (value) => value.accion === accion
      );
      this.modalMotivo = true;
    },
    acciones() {
      if (this.motivo == null) {
        this.$swal({
          icon: "warning",
          text: "Seleccione un motivo",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        return false;
      }
      if (this.accion === 1) {
        this.cambiarEstatus(this.item, this.index);
      }
      if (this.accion === 2) {
        this.cambiarEstatus(this.item, this.index);
      }
      if (this.accion === 3) {
        this.cancelarRecibo(this.item);
      }
      if (this.accion === 4) {
        this.cancelarPti(this.item);
      }
    },
    obtenerSesiones() {
      if (this.clinicaSeleccionada !== null) {
        let fechaInicial = this.$global.traerFecha(new Date());

        this.buscando = true;
        const url =
            this.$api +
            "sesion/listaSesionesPorClinica?idClinica=" + this.clinicaSeleccionada + "&fechaInicio=" +
            encodeURIComponent(fechaInicial);

        this.$http
            .get(url)
            .then((response) => {
              if (response.data.data) {
                response.data.data = response.data.data.map((e) => ({
                  cargando: false,
                  cambiarHorario: false,
                  ...e,
                }));
                this.datosTabla = response.data.data;
              }
            })
            .catch((error) => {
              this.errorMensaje(error);
            })
            .finally(() => {
              this.buscando = false;
            });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    cambiarEstatus(sesion, index) {
      this.loaderAcciones = true;
      this.datosTabla[index].cargando = true;
      const url = this.$api + "sesion/cancelar/activar";

      this.$http
          .put(url, this.traerDatos(sesion))
          .then((response) => {
            if (response.status === 200) {
              if(response.data.data===false){
              
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "El paciente ya cuenta con una sesión activa, no se puede abrir otra.",
              });
            }
              
            //  this.putCambiarEstatusSolicitud(sesion.idRecibo);
              this.obtenerSesiones();
              this.cerrarModal();
            }
          })
          .finally(() => {
            this.loaderAcciones = false;
          })
          .catch((err) => {
            this.showErroMsgPost(err);
          });
    },
    traerDatos(sesion) {
      let estatus = 1;
      let comentario = "ACTIVAR SESION";
      if (sesion.idEstatus === 1) {
        estatus = 15;
        comentario = "CANCELAR SESION";
      }

      return {
        idSesion: sesion.idSesion,
        estatus: estatus,
        usuarioLogueado: this.$localStorageService.getIdUsuario(),
        idClinica: this.clinicaSeleccionada,
        idPaciente: sesion.idPaciente,
        comentarios: comentario,
        motivo: this.motivo.idMotivo,
      };
    },
    cambiarSalida(sesion) {
      sesion.cambiarHorario = !sesion.cambiarHorario;

      if (!sesion.cambiarHorario) {
        const hora = sesion.horaFin.split(":");

        const f = new Date();
        f.setHours(hora[0], hora[1], hora[2], 999);

        sesion.horaFin = this.$moment(f)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        this.guardarSalida(sesion);
      }
    },
    guardarSalida(sesion) {
      const parametros = {
        idSesion: sesion.idSesion,
        hora: sesion.horaFin,
        usuarioLogueado: this.$localStorageService.getIdUsuario(),
      };
      const url = this.$api + "sesion/horario/salida";

      this.$http
          .put(url, parametros)
          .then((response) => {
            if (response.status === 200) {
              this.obtenerSesiones();
            }
          })
          .catch((err) => {
            this.errorEnvio(err);
          });
    },
    async cambiarPrecio(item) {
      this.nombrePaciente = item.paciente;
      this.listaTrt = item.tratamientos;

      this.lstPlanesPaciente = [];
      await this.$http
          .post(this.$api + "paciente/perfiles/obtenerPlanesPaciente",
              {idPaciente: item.idPaciente})
          .then((response) => {
            let datosPlanes = response.data.data;
            let planActivo = datosPlanes.filter(item=>{
              return item.registroActivoPacientePlan == true && item.registroActivoPlan == true && item.suspendidoPlan == false;
            })
            let planInactivo = datosPlanes.filter(item=>{
              return (item.registroActivoPacientePlan == false || item.registroActivoPlan == false) && item.suspendidoPlan == false;
            })
            let suspendidoPlan = datosPlanes.filter(item=>{
              return item.suspendidoPlan == true;
            })

            if(planActivo.length > 0){
              this.lstPlanesPaciente.push({label: 'Planes Activos',
                options: planActivo
              })
            }

            if(planInactivo.length > 0){
              this.lstPlanesPaciente.push({label: 'Planes Inactivos',
                options: planInactivo
              })
            }

            if(suspendidoPlan.length > 0){
              this.lstPlanesPaciente.push({label: 'Planes Suspendidos',
                options: suspendidoPlan
              })
            }
            //this.lstPlanesPaciente = response.data.data
          })
          .catch((err) => {
            this.errorMensaje(err);
          });
      this.$refs["precios"].show();
      this.obtenerEmpleados();
    },
    cambiarSaldoFavor(item) {
      this.nombrePaciente = item.paciente;
      this.idPaciente = item.idPaciente;
      this.$refs["saldo"].show();
    },
    cerrarModal() {
      this.modalMotivo = false;
    },
    cancelarRecibo(item) {
      this.loaderAcciones = true;
            const params = {
              idRecibo: item.idRecibo,
              idMotivo: this.motivo.idMotivo
            }
      this.$http
          .post(
              this.$api +
              "fiscales/recibo/cancelar", params  )
          .then((respuesta) => {
            if (respuesta.data.data) {

              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se canceló el recibo",
              });
              this.obtenerSesiones();
              this.cerrarModal();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Error al cancelar el recibo",
              });
            }
          })
          .catch(error => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
            this.loaderAcciones = true;
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
    },
    cancelarPti(item) {
      this.loaderAcciones = true;
      this.$http
          .delete(
              this.$api +
              "pti/cancelar/pti?idPti=" +
              item.idPti +
              "&motivo=" +
              this.motivo.idMotivo
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se canceló el pti",
              });
              this.obtenerSesiones();
              this.cerrarModal();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Error al cancelar el pti",
              });
            }
          }).catch(reason => {
        console.error(reason)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Error al cancelar el pti",
        });
      })
          .finally(() => {
            this.loaderAcciones = false;
          });
    },
    /*putCambiarEstatusSolicitud(recibo){
       var params = { 
          idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
          idEstatus: 2,
        };

        this.$http
          .put(
            this.$api +
              "pti/bandeja/cobro/cambiarEstatusSolicitud/poridrecibo?idRecibo=" + recibo,
            params
          )
          .then((response) => {
            return response;
          })
          .catch((error) => {
            console.error(error);
          });
    },*/
    obtenerPtisPaciente(idPaciente) {

      const url = this.$api + "pti/obtenerPaciente/ptis?idPaciente="+idPaciente;
      this.$http
          .get(url)
          .then((response) => {
            if (response.status === 200) {
              this.lstIdsPtis = response.data.data;
            }
          })
          .finally(() => {

          })
          .catch((err) => {
            this.showErroMsgPost(err);
          });
    },
    activarPTI(item){
      this.modalActivarPTI = true;
      this.lstIdsPtis = [];
      this.ptiSeleccionado = null;
      this.motivo = null;
      this.motivosFiltrados = this.motivos.filter(
          (value) => value.accion === 6
      );
      this.obtenerPtisPaciente(item.idPaciente);
    },
    cerrarModaLActivarPTI() {
      this.modalActivarPTI = false;
    },
    guardarActivacionPti() {
      if (this.motivo == null) {
        this.$swal({
          icon: "warning",
          text: "Seleccione un motivo",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        return false;
      }
      if (this.ptiSeleccionado == null) {
        this.$swal({
          icon: "warning",
          text: "Seleccione un pti",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        return false;
      }
      this.loaderAcciones = true;
      this.$http
          .delete(
              this.$api +
              "pti/activar/pti?idPti=" +
              this.ptiSeleccionado +
              "&motivo=" +
              this.motivo.idMotivo
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se activo el pti",
              });
              this.obtenerSesiones();
              this.cerrarModaLActivarPTI();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Error al activar el pti",
              });
            }
          }).catch(reason => {
        console.error(reason)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Error al cancelar el pti",
        });
      })
          .finally(() => {
            this.loaderAcciones = false;
          });
    },
  },
  notifications: {
    errorMensaje: {
      type: "error",
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: "error",
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style scoped>
</style>
